import * as THREE from 'three'
import gsap from 'gsap'
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';

//Kaart shader
import badge_vertex from '../Shaders/badgeShader/badge_vertex.js'
import badge_fragment from '../Shaders/badgeShader/badge_fragment.js'
import { DoubleSide } from 'three'

export default class Route {
    constructor(world) {
        this.world = world
        this.scene = this.world.scenes['scene-1']
        this.resources = this.world.stateController.resources.items
        this.time = this.world.time
        this.debug = this.world.debug
        this.camera = this.world.camera.perspectiveCamera
        this.sizes = this.world.sizes

        //Setup
        this.setDebug()
        this.setBadge()
        this.setText()
        this.setRoute()
    }

    setDebug() {
        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Badges')
            //this.debugFolder.close()
            this.routeFolder = this.debug.ui.addFolder('Route')
            this.routeFolder.close()
        }
    }

    // //////////////////////////////////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////////////////

    setBadge() {    
        //3D UI texture
        this.ui_element_Texture = this.resources.ui_element
        this.ui_element_Texture.encoding = THREE.sRGBEncoding
        this.ui_element_Texture.flipY = false

        //Icons image
        this.ui_icons_image_Texture = this.resources.ui_icons_image
        this.ui_icons_image_Texture.encoding = THREE.sRGBEncoding
        this.ui_icons_image_Texture.flipY = false

        //Icons red
        this.ui_icons_red_Texture = this.resources.ui_icons_red
        this.ui_icons_red_Texture.encoding = THREE.sRGBEncoding
        this.ui_icons_red_Texture.flipY = false

        //Icons gray
        this.ui_icons_gray_Texture = this.resources.ui_icons_gray
        this.ui_icons_gray_Texture.encoding = THREE.sRGBEncoding
        this.ui_icons_gray_Texture.flipY = false

        // //////////////////////////////////////////////////////////////////////////////////////
        // Badge ui shader test
        // //////////////////////////////////////////////////////////////////////////////////////
        this.uniforms1 = THREE.UniformsUtils.merge([
            THREE.UniformsLib.common,
            THREE.UniformsLib.fog,
            {
                t1: {value: this.ui_icons_red_Texture},
                t2: {value: this.ui_icons_gray_Texture},
                t3: {value: this.ui_icons_image_Texture},
                uDisplacement: { value: this.resources.displacementTexture },
                transition1: {value: 0},
                transition2: {value: 0},
            }
        ])
        this.uniforms2 = THREE.UniformsUtils.merge([
            THREE.UniformsLib.common,
            THREE.UniformsLib.fog,
            {
                t1: {value: this.ui_icons_red_Texture},
                t2: {value: this.ui_icons_gray_Texture},
                t3: {value: this.ui_icons_image_Texture},
                uDisplacement: { value: this.resources.displacementTexture },
                transition1: {value: 1},
                transition2: {value: 0},
            }
        ])
        this.uniforms3 = THREE.UniformsUtils.merge([
            THREE.UniformsLib.common,
            THREE.UniformsLib.fog,
            {
                t1: {value: this.ui_icons_red_Texture},
                t2: {value: this.ui_icons_gray_Texture},
                t3: {value: this.ui_icons_image_Texture},
                uDisplacement: { value: this.resources.displacementTexture },
                transition1: {value: 1},
                transition2: {value: 0},
            }
        ])
        this.uniforms4 = THREE.UniformsUtils.merge([
            THREE.UniformsLib.common,
            THREE.UniformsLib.fog,
            {
                t1: {value: this.ui_icons_red_Texture},
                t2: {value: this.ui_icons_gray_Texture},
                t3: {value: this.ui_icons_image_Texture},
                uDisplacement: { value: this.resources.displacementTexture },
                transition1: {value: 1},
                transition2: {value: 0},
            }
        ])
        this.uniforms5 = THREE.UniformsUtils.merge([
            THREE.UniformsLib.common,
            THREE.UniformsLib.fog,
            {
                t1: {value: this.ui_icons_red_Texture},
                t2: {value: this.ui_icons_gray_Texture},
                t3: {value: this.ui_icons_image_Texture},
                uDisplacement: { value: this.resources.displacementTexture },
                transition1: {value: 1},
                transition2: {value: 0},
            }
        ])
        this.uniforms6 = THREE.UniformsUtils.merge([
            THREE.UniformsLib.common,
            THREE.UniformsLib.fog,
            {
                t1: {value: this.ui_icons_red_Texture},
                t2: {value: this.ui_icons_gray_Texture},
                t3: {value: this.ui_icons_image_Texture},
                uDisplacement: { value: this.resources.displacementTexture },
                transition1: {value: 1},
                transition2: {value: 0},
            }
        ])
        this.uniforms7 = THREE.UniformsUtils.merge([
            THREE.UniformsLib.common,
            THREE.UniformsLib.fog,
            {
                t1: {value: this.ui_icons_red_Texture},
                t2: {value: this.ui_icons_gray_Texture},
                t3: {value: this.ui_icons_image_Texture},
                uDisplacement: { value: this.resources.displacementTexture },
                transition1: {value: 1},
                transition2: {value: 0},
            }
        ])
        this.uniforms8 = THREE.UniformsUtils.merge([
            THREE.UniformsLib.common,
            THREE.UniformsLib.fog,
            {
                t1: {value: this.ui_icons_red_Texture},
                t2: {value: this.ui_icons_gray_Texture},
                t3: {value: this.ui_icons_image_Texture},
                uDisplacement: { value: this.resources.displacementTexture },
                transition1: {value: 1},
                transition2: {value: 0},
            }
        ])

        // //////////////////////////////////////////////////////////////////////////////////////
        // //////////////////////////////////////////////////////////////////////////////////////
        // //////////////////////////////////////////////////////////////////////////////////////

        //badge shader materials
        this.ui_badge1_material = new THREE.ShaderMaterial({
            uniforms: this.uniforms1,
            fog: true,
            transparent: true,
            vertexShader: badge_vertex,
            fragmentShader: badge_fragment,
        });
        this.ui_badge2_material = new THREE.ShaderMaterial({
            uniforms: this.uniforms2,
            fog: true,
            transparent: true,
            vertexShader: badge_vertex,
            fragmentShader: badge_fragment,
        });
        this.ui_badge3_material = new THREE.ShaderMaterial({
            uniforms: this.uniforms3,
            fog: true,
            transparent: true,
            vertexShader: badge_vertex,
            fragmentShader: badge_fragment,
        });
        this.ui_badge4_material = new THREE.ShaderMaterial({
            uniforms: this.uniforms4,
            fog: true,
            transparent: true,
            vertexShader: badge_vertex,
            fragmentShader: badge_fragment,
        });
        this.ui_badge5_material = new THREE.ShaderMaterial({
            uniforms: this.uniforms5,
            fog: true,
            transparent: true,
            vertexShader: badge_vertex,
            fragmentShader: badge_fragment,
        });
        this.ui_badge6_material = new THREE.ShaderMaterial({
            uniforms: this.uniforms6,
            fog: true,
            transparent: true,
            vertexShader: badge_vertex,
            fragmentShader: badge_fragment,
        });
        this.ui_badge7_material = new THREE.ShaderMaterial({
            uniforms: this.uniforms7,
            fog: true,
            transparent: true,
            vertexShader: badge_vertex,
            fragmentShader: badge_fragment,
        });
        this.ui_badge8_material = new THREE.ShaderMaterial({
            uniforms: this.uniforms8,
            fog: true,
            transparent: true,
            vertexShader: badge_vertex,
            fragmentShader: badge_fragment,
        });

        // //////////////////////////////////////////////////////////////////////////////////////
        // //////////////////////////////////////////////////////////////////////////////////////
        // //////////////////////////////////////////////////////////////////////////////////////

        //Creating the animated materials
        this.ui_element_Material = []
        for (var i = 1; i < 9; ++i) {
            this.ui_element_Material[i] = new THREE.MeshBasicMaterial({
                map: this.ui_element_Texture.clone(),
                transparent: true,
                //fog: false
            })
            this.ui_element_Material[i].map.offset.x = 1
            this.ui_element_Material.push(this.ui_element_Material[i])
        }

        //pre-load the ui texture
        this.world.renderer.instance.initTexture(this.ui_element_Texture)

        //loading de gltf
        this.ui_element_Gltf = this.resources.ui_element_Gltf
        this.ui_element_Model = this.ui_element_Gltf.scene
        this.scene.add(this.ui_element_Model)
        // console.log(this.ui_element_Model)

        //////////////////////////////////////////////////////////////////////
        //badge 1
        //////////////////////////////////////////////////////////////////////

        //naming the 3D elements
        this.element1 = this.ui_element_Model.children.find((child) => child.name === 'H1')
        this.badge1 = this.element1.children.find((child) => child.name === 'Pentagon')
        this.badge1Top = this.element1.children.find((child) => child.name === 'Balk_boven')
        this.badge1Bottom = this.element1.children.find((child) => child.name === 'Balk_onder')

        //positioning
        this.element1.position.set(4.8, 1.5, 3.2)

        //adding the materials
        this.badge1.material = this.ui_badge1_material
        this.badge1Top.material =  this.ui_element_Material[1]
        this.badge1Bottom.material = this.ui_element_Material[1]

        //////////////////////////////////////////////////////////////////////
        //badge 2
        //////////////////////////////////////////////////////////////////////

        //naming the 3D elements
        this.element2 = this.ui_element_Model.children.find((child) => child.name === 'H2')
        this.badge2 = this.element2.children.find((child) => child.name === 'Pentagon001')
        this.badge2Top = this.element2.children.find((child) => child.name === 'Balk_boven001')
        this.badge2Bottom = this.element2.children.find((child) => child.name === 'Balk_onder001')

        //positioning
        this.element2.position.set(-4, 1.5, -1.2)

        //adding the materials
        this.badge2.material = this.ui_badge2_material
        this.badge2Top.material = this.ui_element_Material[2]
        this.badge2Bottom.material = this.ui_element_Material[2]

        //////////////////////////////////////////////////////////////////////
        //badge 3
        //////////////////////////////////////////////////////////////////////

        //naming the 3D elements
        this.element3 = this.ui_element_Model.children.find((child) => child.name === 'H3')
        this.badge3 = this.element3.children.find((child) => child.name === 'Pentagon002')
        this.badge3Top = this.element3.children.find((child) => child.name === 'Balk_boven002')
        this.badge3Bottom = this.element3.children.find((child) => child.name === 'Balk_onder002')

        //positioning
        this.element3.position.set(4.9, 1.5, -12)

        //adding the materials
        this.badge3.material = this.ui_badge3_material
        this.badge3Top.material = this.ui_element_Material[3]
        this.badge3Bottom.material = this.ui_element_Material[3]

        //////////////////////////////////////////////////////////////////////
        //badge 4
        //////////////////////////////////////////////////////////////////////

        //naming the 3D elements
        this.element4 = this.ui_element_Model.children.find((child) => child.name === 'H4')
        this.badge4 = this.element4.children.find((child) => child.name === 'Pentagon003')
        this.badge4Top = this.element4.children.find((child) => child.name === 'Balk_boven003')
        this.badge4Bottom = this.element4.children.find((child) => child.name === 'Balk_onder003')

        //positioning
        this.element4.position.set(0.28, 1.5, -12.75)

        //adding the materials
        this.badge4.material = this.ui_badge4_material
        this.badge4Top.material = this.ui_element_Material[4]
        this.badge4Bottom.material = this.ui_element_Material[4]

        //////////////////////////////////////////////////////////////////////
        //badge 5
        //////////////////////////////////////////////////////////////////////

        //naming the 3D elements
        this.element5 = this.ui_element_Model.children.find((child) => child.name === 'H5')
        this.badge5 = this.element5.children.find((child) => child.name === 'Pentagon004')
        this.badge5Top = this.element5.children.find((child) => child.name === 'Balk_boven004')
        this.badge5Bottom = this.element5.children.find((child) => child.name === 'Balk_onder004')

        //positioning
        this.element5.position.set(-7.66, 1.5, -6.6)

        //adding the materials
        this.badge5.material = this.ui_badge5_material
        this.badge5Top.material = this.ui_element_Material[5]
        this.badge5Bottom.material = this.ui_element_Material[5]

        //////////////////////////////////////////////////////////////////////
        //badge 6
        //////////////////////////////////////////////////////////////////////

        //naming the 3D elements
        this.element6 = this.ui_element_Model.children.find((child) => child.name === 'H6')
        this.badge6 = this.element6.children.find((child) => child.name === 'Pentagon005')
        this.badge6Top = this.element6.children.find((child) => child.name === 'Balk_boven005')
        this.badge6Bottom = this.element6.children.find((child) => child.name === 'Balk_onder005')

        //positioning
        this.element6.position.set(-3.5, 1.5, 2.87)

        //adding the materials
        this.badge6.material = this.ui_badge6_material
        this.badge6Top.material = this.ui_element_Material[6]
        this.badge6Bottom.material = this.ui_element_Material[6]

        //////////////////////////////////////////////////////////////////////
        //badge 7
        //////////////////////////////////////////////////////////////////////

        //naming the 3D elements
        this.element7 = this.ui_element_Model.children.find((child) => child.name === 'H7')
        this.badge7 = this.element7.children.find((child) => child.name === 'Pentagon006')
        this.badge7Top = this.element7.children.find((child) => child.name === 'Balk_boven006')
        this.badge7Bottom = this.element7.children.find((child) => child.name === 'Balk_onder006')

        //positioning
        this.element7.position.set(-0.75, 1.5, 3.8)

        //adding the materials
        this.badge7.material = this.ui_badge7_material
        this.badge7Top.material = this.ui_element_Material[7]
        this.badge7Bottom.material = this.ui_element_Material[7]

        //////////////////////////////////////////////////////////////////////
        //badge 8
        //////////////////////////////////////////////////////////////////////

        //naming the 3D elements
        this.element8 = this.ui_element_Model.children.find((child) => child.name === 'H8')
        this.badge8 = this.element8.children.find((child) => child.name === 'Pentagon007')
        this.badge8Top = this.element8.children.find((child) => child.name === 'Balk_boven007')
        this.badge8Bottom = this.element8.children.find((child) => child.name === 'Balk_onder007')

        //positioning
        this.element8.position.set(2, 1.5, 10.7)

        //adding the materials
        this.badge8.material = this.ui_badge8_material
        this.badge8Top.material = this.ui_element_Material[8]
        this.badge8Bottom.material = this.ui_element_Material[8]

        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        if (this.debug.active) {
            this.debugFolder.add(this.element1, 'visible').name('POI badges')
            .onChange(() =>
            {
                this.element2.visible = this.element1.visible
                this.element3.visible = this.element1.visible
                this.element4.visible = this.element1.visible
                this.element5.visible = this.element1.visible
                this.element6.visible = this.element1.visible
                this.element7.visible = this.element1.visible
                this.element8.visible = this.element1.visible
                //
                this.world.world.raycast.poi1Active = true
                this.world.world.raycast.poi2Active = true
                this.world.world.raycast.poi3Active = true
                this.world.world.raycast.poi4Active = true
                this.world.world.raycast.poi5Active = true
                this.world.world.raycast.poi6Active = true
                this.world.world.raycast.poi7Active = true
                this.world.world.raycast.poi8Active = true      
            })
        }
        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
    }

    // //////////////////////////////////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////////////////

    setText() {
        //create the text elements

        for (let i = 1; i <= 8; i++) {
            this['h' + i] = document.createElement('h1');
            this['p' + i] = document.createElement('p');

            this['p' + i + 'Video'] = document.createElement('iframe');
            this['p' + i + 'Video'].frameBorder = 0;
            this['p' + i + 'Video'].setAttribute('allowfullscreen', 'allowfullscreen');
        }

        this.h1.textContent = 'ARNHEM'
        this.h2.textContent = 'EDE'
        this.h3.textContent = 'APELDOORN'
        this.h4.textContent = 'UDDEL'
        this.h5.textContent = 'BARNEVELD'
        this.h6.textContent = 'WAGENINGEN'
        this.h7.textContent = 'RENKUM'
        this.h8.textContent = 'NIJMEGEN'

        this.p1.textContent = 'Godfrey Freeman thought long and hard about where his story should begin. According to him, the best place was the basement of the Rijkswaterstaat building, opposite the northern end of the Colonel Frost bridge in Arnhem, on the night of September 20, 1944.'
        this.p2.textContent = 'While Arnhemmers are forced to leave the city in long queues, Godfrey drives past them in an open military truck. A bitter feeling, because they have not been liberated by the Allies like him, but are still occupied and forced to leave hearth and home behind.'
        this.p3.textContent = 'The great palace had been commandeered as a hospital by the German forces and huge red crosses on white backgrounds had been painted on the roofs.'
        this.p4.textContent = '"I did not know the farmer`s name and I did not ask. Because under pressure one cannot betray secrets that one does not know. The farmer, his wife, two children and a girl from Arnhem who had been evacuated lived in this small home port.”'
        this.p5.textContent = '“I was struck by how young our guides were. Fifteen, sixteen maybe? Involuntarily my thoughts turned to all these people, including women, who were willing to risk everything for our freedom. It was all too clear what awaited them if they were caught.”'
        this.p6.textContent = '“The hundred soldiers are forced to wait. In the woods. Surrounded by German armies and cannons, they eat and drink quietly like a large surrealist picnic.”'
        this.p7.textContent = '“Night falls. It is finally here. With burnt corks they blacken their faces and the backs of their hands. This would be the last effort. The last attempt to reach Allied lines and freedom.”'
        this.p8.textContent = '“My thoughts go out to the underground, to the brave men and women who risked their lives to save us. Not once, but many times. For them there was not yet the prospect of freedom, for them there was no liberation army to welcome them.”'

        this.p1Video.src = 'https://player.vimeo.com/video/454682031';
        this.p2Video.src = 'https://player.vimeo.com/video/454425824';
        this.p3Video.src = 'https://player.vimeo.com/video/454425526';
        this.p4Video.src = 'https://player.vimeo.com/video/454426543';
        this.p5Video.src = 'https://player.vimeo.com/video/454426364';
        this.p6Video.src = 'https://player.vimeo.com/video/454426100';
        this.p7Video.src = 'https://player.vimeo.com/video/454426893';
        this.p8Video.src = 'https://player.vimeo.com/video/454427160';

        // Create a container for the text
        this.div_text = document.createElement('div')
        this.div_text.classList.add("text_div")

        this.div_container = new CSS2DObject(this.div_text)
        this.scene.add(this.div_container)
    }

    // //////////////////////////////////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////////////////

    setRoute() {
        //loading de gltf
        this.routeGltf = this.resources.routeGltf
        this.route_Model = this.routeGltf.scene
        this.scene.add(this.route_Model)
        // console.log(this.route_Model)

        //Selectie texture
        this.selectieTexture = this.resources.selectieTexture
        this.selectieTexture.encoding = THREE.sRGBEncoding
        this.selectieTexture.flipY = false
        this.selectieTexture.magFilter = THREE.NearestFilter

        this.selectieMaterial = new THREE.MeshBasicMaterial({ 
            map: this.selectieTexture,
            transparent: true,
            side: DoubleSide,
         })

        //Route texture
        this.routeTexture = this.resources.routeTexture
        this.routeTexture.encoding = THREE.sRGBEncoding
        this.routeTexture.flipY = false
        this.routeTexture.magFilter = THREE.NearestFilter

        //Offset the texture
        this.routeTexture.offset.x = 1

        //Material for each of the routes (zodat ze los van elkaar te animeren zijn)
        this.route_1_material = new THREE.MeshBasicMaterial({ 
            map: this.routeTexture.clone(),
            transparent: true,
            side: DoubleSide,
            opacity: 0.4,
        })
        this.route_2_material = new THREE.MeshBasicMaterial({ 
            map: this.routeTexture.clone(),
            transparent: true,
            side: DoubleSide,
            opacity: 0.4,
        })
        this.route_3_material = new THREE.MeshBasicMaterial({ 
            map: this.routeTexture.clone(),
            transparent: true,
            side: DoubleSide,
            opacity: 0.4,
        })
        this.route_4_material = new THREE.MeshBasicMaterial({ 
            map: this.routeTexture.clone(),
            transparent: true,
            side: DoubleSide,
            opacity: 0.4,
        })
        this.route_5_material = new THREE.MeshBasicMaterial({ 
            map: this.routeTexture.clone(),
            transparent: true,
            side: DoubleSide,
            opacity: 0.4,
        })
        this.route_6_material = new THREE.MeshBasicMaterial({ 
            map: this.routeTexture.clone(),
            transparent: true,
            side: DoubleSide,
            opacity: 0.4,
        })
        this.route_7_material = new THREE.MeshBasicMaterial({ 
            map: this.routeTexture.clone(),
            transparent: true,
            side: DoubleSide,
            opacity: 0.4,
        })

        ////////////////////////////////////////////

        this.routes = this.route_Model.getObjectByName('Lijnen')
        this.routes.position.y -= 0.06

        //Lines
        this.route_1 = this.routes.getObjectByName('Lijn_1>2')
        this.route_2 = this.routes.getObjectByName('Lijn_2>3')
        this.route_3 = this.routes.getObjectByName('Lijn_3>4')
        this.route_4 = this.routes.getObjectByName('Lijn_4>5')
        this.route_5 = this.routes.getObjectByName('Lijn_5>6')
        this.route_6 = this.routes.getObjectByName('Lijn_6>7')
        this.route_7 = this.routes.getObjectByName('Lijn_7>8')

        this.route_1.material = this.route_1_material
        this.route_2.material = this.route_2_material
        this.route_3.material = this.route_3_material
        this.route_4.material = this.route_4_material
        this.route_5.material = this.route_5_material
        this.route_6.material = this.route_6_material
        this.route_7.material = this.route_7_material

        //Steden rand
        this.steden_rand = this.route_Model.getObjectByName('Steden_randen')
        this.steden_rand.position.y -= 0.2

        //Steden rand groups
        this.arnhem_rand = this.steden_rand.getObjectByName('1_Arnhem')
        this.ede_rand = this.steden_rand.getObjectByName('2_Ede')
        this.apeldoorn_rand = this.steden_rand.getObjectByName('3_Apeldoorn')
        this.uddel_rand = this.steden_rand.getObjectByName('4_Uddel')
        this.barneveld_rand = this.steden_rand.getObjectByName('5_Barneveld')
        this.wageningen_rand = this.steden_rand.getObjectByName('6_Wageningen')
        this.renkum_rand = this.steden_rand.getObjectByName('7_Renkum')
        this.nijmegen_rand = this.steden_rand.getObjectByName('8_Nijmegen')

        //Steden rand materials
        this.arnhem_rand.children[0].material = this.selectieMaterial
        this.arnhem_rand.children[1].material = this.selectieMaterial
        this.ede_rand.children[0].material = this.selectieMaterial
        this.ede_rand.children[1].material = this.selectieMaterial
        this.apeldoorn_rand.children[0].material = this.selectieMaterial
        this.apeldoorn_rand.children[1].material = this.selectieMaterial
        this.uddel_rand.children[0].material = this.selectieMaterial
        this.uddel_rand.children[1].material = this.selectieMaterial
        this.barneveld_rand.children[0].material = this.selectieMaterial
        this.barneveld_rand.children[1].material = this.selectieMaterial
        this.wageningen_rand.children[0].material = this.selectieMaterial
        this.wageningen_rand.children[1].material = this.selectieMaterial
        this.renkum_rand.children[0].material = this.selectieMaterial
        this.renkum_rand.children[1].material = this.selectieMaterial
        this.nijmegen_rand.children[0].material = this.selectieMaterial
        this.nijmegen_rand.children[1].material = this.selectieMaterial
    }

    // //////////////////////////////////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////////////////

    update() {
        //POI badges rotation with camera
        this.element1.quaternion.slerp(this.camera.quaternion, 0.1)
        this.element2.quaternion.slerp(this.camera.quaternion, 0.1)
        this.element3.quaternion.slerp(this.camera.quaternion, 0.1)
        this.element4.quaternion.slerp(this.camera.quaternion, 0.1)
        this.element5.quaternion.slerp(this.camera.quaternion, 0.1)
        this.element6.quaternion.slerp(this.camera.quaternion, 0.1)
        this.element7.quaternion.slerp(this.camera.quaternion, 0.1)
        this.element8.quaternion.slerp(this.camera.quaternion, 0.1)

        //camera y position
        var y_zoom = this.camera.position.y;

        //mapping badge scale to camera y
        var badge_scale_map = gsap.utils.mapRange(2, 24, 0.05, 0.18, y_zoom)

        //applying the scales to the badges
        this.element1.scale.set(badge_scale_map, badge_scale_map, badge_scale_map)
        this.element2.scale.set(badge_scale_map, badge_scale_map, badge_scale_map)
        this.element3.scale.set(badge_scale_map, badge_scale_map, badge_scale_map)
        this.element4.scale.set(badge_scale_map, badge_scale_map, badge_scale_map)
        this.element5.scale.set(badge_scale_map, badge_scale_map, badge_scale_map)
        this.element6.scale.set(badge_scale_map, badge_scale_map, badge_scale_map)
        this.element7.scale.set(badge_scale_map, badge_scale_map, badge_scale_map)
        this.element8.scale.set(badge_scale_map, badge_scale_map, badge_scale_map)

        //mapping badge pos y to camera y
        var badge_pos_map = gsap.utils.mapRange(2, 24, 0.5, 1.5, y_zoom)
        var badge_pos_arnhem_map = gsap.utils.mapRange(2, 24, 0.3, 1.5, y_zoom)
        var badge_pos_ede_map = gsap.utils.mapRange(2, 24, 0.37, 1.5, y_zoom)
        var badge_pos_uddel_map = gsap.utils.mapRange(2, 24, 0.35, 1.5, y_zoom)
        var badge_pos_barneveld_map = gsap.utils.mapRange(2, 24, 0.38, 1.5, y_zoom)
        var badge_pos_renkum_map = gsap.utils.mapRange(2, 24, 0.37, 1.5, y_zoom)
        var badge_pos_nijmegen_map = gsap.utils.mapRange(2, 24, 0.4, 1.5, y_zoom)

        this.element1.position.y = badge_pos_arnhem_map
        this.element2.position.y = badge_pos_ede_map
        this.element3.position.y = badge_pos_map
        this.element4.position.y = badge_pos_uddel_map
        this.element5.position.y = badge_pos_map
        this.element6.position.y = badge_pos_barneveld_map
        this.element7.position.y = badge_pos_renkum_map
        this.element8.position.y = badge_pos_nijmegen_map
    } 
}



